// Generated by CoffeeScript 2.4.1
(function() {
  var NodeOperation, Weaver, _, graphOr, idOr, idOrFail, idOrGenerate, util;

  Weaver = require('./Weaver');

  util = require('./util');

  _ = require('lodash');

  idOr = function(...values) {
    var backups, val;
    [val, ...backups] = values;
    if (val == null) {
      if ((backups != null) && backups.length > 0) {
        return idOr(...backups);
      } else {
        return void 0;
      }
    } else if (_.isString(val)) {
      return val;
    } else if (val instanceof Weaver.Node) {
      return val.id();
    } else {
      throw new Error(`Value ${val} can not be used to get an id`);
    }
  };

  idOrGenerate = function(...values) {
    return idOr(...values) || Weaver.Node.generateId();
  };

  idOrFail = function(...values) {
    return idOr(...values) || (function() {
      throw new Error('No id supplied');
    })();
  };

  graphOr = function(...values) {
    var backups, val;
    [val, ...backups] = values;
    if (val == null) {
      if ((backups != null) && backups.length > 0) {
        return graphOr(...backups);
      } else {
        return void 0;
      }
    } else if (_.isString(val)) {
      return val;
    } else if (val instanceof Weaver.Node) {
      return val.getGraph();
    } else if (val instanceof Weaver.Graph) {
      return val.id();
    } else {
      throw new Error(`Value ${val} can not be used to get an graph`);
    }
  };

  NodeOperation = function(node) {
    return {
      createNode: function(upsert = false) {
        var result;
        result = {
          action: "create-node",
          id: node.id(),
          graph: node.getGraph()
        };
        if (upsert) {
          result.upsert = upsert;
        }
        return result;
      },
      removeNode: function() {
        return {
          cascade: true,
          action: "remove-node",
          id: node.id(),
          graph: node.getGraph(),
          removeId: Weaver.Node.generateId(),
          removeGraph: node.getGraph()
        };
      },
      removeNodeUnrecoverable: function() {
        return removeNode();
      },
      changeAttributeKey: function(attr, value) {
        var attData, ref, rel;
        ref = node._attributes;
        for (rel in ref) {
          attData = ref[rel];
          if (_.find(attData._pendingWrites, {
            action: 'create-attribute'
          }) != null) {
            throw new Error('This operation is not allowed together with other create attribute operations');
          }
        }
        return {
          action: 'change-attribute-key',
          id: node.id(),
          attributeKey: attr,
          newAttributeKey: value,
          graph: node.getGraph()
        };
      },
      changeNodeId: function(newId) {
        return {
          action: "change-node-id",
          id: newId,
          oldId: node.id(),
          graph: node.getGraph()
        };
      },
      changeNodeGraph: function(newGraph) {
        return {
          action: "change-node-graph",
          id: node.id(),
          oldGraph: node.getGraph(),
          graph: newGraph
        };
      },
      createAttribute: function(params) {
        var hasChangeAttribute;
        // Search if change attribute key operation exists already for this key
        hasChangeAttribute = _.find(node._pendingWrites, {
          action: 'change-attribute-key'
        });
        if (hasChangeAttribute != null) {
          throw new Error('This operation is not allowed together with change attribute operation');
        }
        return {
          action: "create-attribute",
          id: idOrGenerate(params.id, params.node),
          graph: graphOr(params.graph, params.node, node.getGraph()),
          sourceId: idOrFail(node),
          sourceGraph: graphOr(node),
          key: params.key || (function() {
            throw new Error('No key supplied');
          })(),
          value: params.value,
          datatype: params.dataType, // todo: update the connector to use dataType
          replacesId: idOr(params.replaces),
          replacesGraph: graphOr(params.replaces),
          replaceId: params.replaces != null ? Weaver.Node.generateId() : null, // doesnt work well when undefined
          replaceGraph: params.replaces != null ? node.getGraph() : void 0,
          upsert: params.upsert || false
        };
      },
      removeAttribute: function(params) {
        return {
          cascade: true,
          action: "remove-attribute",
          replacesId: idOrFail(params.id, params.node),
          replacesGraph: graphOr(params.graph, params.node)
        };
      },
      createRelation: function(params) {
        var hasChangeRelation;
        // Search if change relation key operation exists already for this key
        hasChangeRelation = _.find(node._pendingWrites, {
          action: 'change-relation-key'
        });
        if (hasChangeRelation != null) {
          throw new Error('This operation is not allowed together with change relation key operation');
        }
        return {
          action: "create-relation",
          id: idOrGenerate(params.id, params.node),
          graph: graphOr(params.graph, params.node, node.getGraph()),
          sourceId: idOrFail(node),
          sourceGraph: graphOr(node),
          key: params.key || (function() {
            throw new Error('No key supplied');
          })(),
          targetId: idOrFail(params.to),
          targetGraph: graphOr(params.to),
          replacesId: idOr(params.replaces),
          replacesGraph: graphOr(params.replaces),
          replaceId: params.replaces != null ? Weaver.Node.generateId() : void 0,
          replaceGraph: params.replaces != null ? node.getGraph() : void 0,
          upsert: params.upsert || false
        };
      },
      removeRelation: function(params) {
        return {
          cascade: true,
          action: "remove-relation",
          replacesId: idOrFail(params.id, params.node),
          replacesGraph: graphOr(params.graph, params.node)
        };
      },
      changeRelationKey: function(attr, value) {
        var ref, rel, relData;
        ref = node._relations;
        for (rel in ref) {
          relData = ref[rel];
          if (_.find(relData._pendingWrites, {
            action: 'create-relation'
          }) != null) {
            throw new Error('This operation is not allowed together with other create relation operations');
          }
        }
        return {
          action: 'change-relation-key',
          id: node.id(),
          relationKey: attr,
          newRelationKey: value,
          graph: node.getGraph()
        };
      },
      applyLabel: function(set) {
        return {
          action: "add-to-set",
          id: node.id(),
          graph: node.getGraph(),
          set
        };
      },
      removeLabel: function(set) {
        return {
          action: "remove-from-set",
          id: node.id(),
          graph: node.getGraph(),
          set
        };
      }
    };
  };

  module.exports = {
    Node: NodeOperation
  };

}).call(this);
